import { has } from 'lodash-es'
import { UpgradeRegistryItem } from '../upgrader.types'
/**
 * component 对应组件类型
 * form 从某个版本开始升级
 * to 升级到的版本
 * upgrade 升级方法，具体的值
 *  {
      from: 1,
      to: 2,
      upgrade(schema) {
        // 添加 autoFitHeight 属性，默认为 false
        // if (!('autoFitHeight' in schema.prop)) {
        //   schema.prop.autoFitHeight = false
        // }
        return schema
      }
    }
 */
export const HHExportBtn: UpgradeRegistryItem = {
  component: 'HHExportBtn',
  upgrades: [
    {
      from: 2,
      to: 3,
      upgrade(schema) {
        if (
          has(schema, 'eventOption') &&
          has(schema.eventOption, 'send') &&
          has(schema.eventOption.send, 'bindValues') &&
          schema.eventOption.send.bindValues.length === 0
        ) {
          schema.eventOption.send.bindValues.push({
            label: '交互值',
            value: 'eventValue'
          })
        }
        if (
          has(schema, 'eventOption') &&
          has(schema.eventOption, 'receive') &&
          has(schema.eventOption.receive, 'operationTypes') &&
          schema.eventOption.receive.operationTypes.findIndex(
            (op: any) => op.value === 'onlyReceiveEvent'
          ) === -1
        ) {
          schema.eventOption.receive.operationTypes.push({
            label: '仅接收值',
            value: 'onlyReceiveEvent'
          })
        }
        return schema
      }
    }
  ]
}
